import { Pipe, PipeTransform } from '@angular/core';
import { DprActivityCustomDataReport } from '@report/models';

@Pipe({
  name: 'customDataValue',
})
export class CustomDataValuePipe implements PipeTransform {
  transform(
    customDataReport: DprActivityCustomDataReport[],
    customDataId: number
  ): string | number {
    if (!customDataReport.length) {
      return '-';
    }

    return (
      customDataReport.find((cd) => cd.customDataId === customDataId)?.value ??
      '-'
    );
  }
}
